import { render, staticRenderFns } from "./advertising.vue?vue&type=template&id=c8c3664a&"
import script from "./advertising.vue?vue&type=script&lang=js&"
export * from "./advertising.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports